<div class="home-page-wrap">
  <div class="bignews-overlay">
    <div *ngIf="news.length > 0" class="main-head-section">
      <p-carousel
        [value]="BannerNews"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="true"
        [autoplayInterval]="6000"
      >
        <ng-template let-data let-i pTemplate="item">
          <div class="ui-g">
            <div class="ui-g-12" style="padding: 0">
              <div
                class="bannerImage"
                [style.backgroundImage]="'url(' + data?.link + ')'"
              >
                <div class="bannerImage-overlay">
                  <div class="carousel-text">
                    {{ data.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>

    <!-- <p-dialog [(visible)]="displayModal" [modal]="true" [style]="{width: '35vw'}"
    [draggable]="false" [resizable]="false">
      <img src="assets/images/newYear2025.jpg" alt="" class="new-image">

      <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="displayModal=false" label="Ok" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog> -->

    <div class="partner">
      <div style="background: white">
        <img src="assets/icons/ntpc.png" alt="" />
        <h2 class="partner-l">A maharatna Company</h2>
      </div>
      <div class="title">
        <h1>Official partners</h1>
        <h2>A maharatna Company</h2>
        <p>
          NTPC is India's largest energy conglomerate with roots planted way
          back in 1975 to accelerate power development in India
        </p>
      </div>
    </div>

    <div class="ui-g news-all">
      <div class="ui-g-8 ui-lg-8 ui-md-12 ui-sm-12">
        <div class="big-news">
          <div class="ui-g">
            <div class="ui-g-6 ui-lg-6 ui-sm-12">
              <div
                class="big-news-image"
                [style.backgroundImage]="'url(' + news[0]?.link + ')'"
              ></div>
            </div>
            <div class="ui-g-6 ui-lg-6 ui-sm-12">
              <div class="big-news-content">
                <h1>
                  {{ news[0]?.title }}
                </h1>
                <p>
                  {{ news[0]?.description }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-6 ui-md-6 ui-sm-12">
            <div class="small-news-row ui-g" style="margin-bottom: 60px">
              <div class="ui-g-4 ui-lg-4 ui-sm-12">
                <div
                  class="img-sm-wrapper"
                  [style.backgroundImage]="'url(' + news[1]?.link + ')'"
                ></div>
              </div>
              <div class="ui-g-8 ui-lg-8 ui-sm-12">
                <p class="sm-news">
                  {{ news[1]?.title }}
                </p>
              </div>
            </div>
          </div>

          <div class="ui-g-6 ui-md-6 ui-sm-12">
            <div class="small-news-row ui-g">
              <div class="ui-g-4 ui-lg-4 ui-sm-12">
                <div
                  class="img-sm-wrapper"
                  [style.backgroundImage]="'url(' + news[2]?.link + ')'"
                ></div>
              </div>
              <div class="ui-g-8 ui-lg-8 ui-sm-12">
                <p class="sm-news">
                  {{ news[2]?.title }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-4 ui-lg-4 ui-md-12 ui-sm-12">
        <div class="twitter-area">
          <a
            class="twitter-timeline"
            href="https://twitter.com/india_archery?ref_src=twsrc%5Etfw"
            >Tweets by india_archery</a
          >
          <script
            async
            src="https://platform.twitter.com/widgets.js"
            charset="utf-8"
          ></script>
        </div>

        <div class="social-icons">
          <a href="https://www.facebook.com/indianarchery/" target="_blank">
            <img src="assets/icons/facebook-logo.png" alt="" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCJINU5svWSsrOnwMYEjITJw"
            target="_blank"
          >
            <img src="assets/icons/youtube.png" alt="" />
          </a>

          <a
            href="https://www.instagram.com/indianarchery/?utm_medium=copy_link"
            target="_blank"
          >
            <img src="assets/icons/instagram.png" alt="" />
          </a>
        </div>
      </div>
    </div>

    <div class="ui-g wrap-main-home">
      <div class="ui-g-3 ui-lg-3 ui-md-12 ui-sm-12">
        <div class="side-section">
          <div class="side-section-heading">
            <span>
              <img src="assets/icons/file.svg" alt="" />
            </span>
            Circular
          </div>

          <div class="side-section-content2">
            <ul>
              <li *ngFor="let data of Circulars">
                <a [href]="global.basePathImage + data.link" target="_blank">
                  {{ data?.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- <div class="side-section">
          <div class="side-section-heading">
            <span>
              <img src="assets/icons/file.svg" alt="" />
            </span>
            AII Election
          </div>

          <div class="side-section-content">
            <ul>
              <li *ngFor="let data of Elections">
                <a [href]="data.link" target="_blank">
                  {{ data?.name }}
                </a>
              </li>
            </ul>
          </div>
        </div> -->
      </div>

      <div class="ui-g-9 ui-lg-9 ui-md-12 ui-sm-12">
        <div class="news-section">
          <!-- <div class="title-header">
          <h1>Latest News</h1>
          <a href="">Latest News</a>
        </div> -->

          <div class="ui-g">
            <div
              *ngFor="let data of news | slice: 0:9"
              class="ui-g-4 ui-lg-4 ui-md-6 ui-sm-12"
            >
              <div class="news-card">
                <div class="image">
                  <div
                    class="news-image"
                    [style.backgroundImage]="'url(' + data?.link + ')'"
                  ></div>
                </div>
                <div class="news-image-line"></div>
                <h2 class="news-heading">
                  {{ data?.title }}
                </h2>
                <p class="news-content">
                  {{ data?.description }}
                </p>
                <a (click)="newsDetails(data._id)" class="read-more"
                  >Read More</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="event-card">
    <div class="ui-g">
      <div class="ui-g-6 ui-sm-12 event-head">
        <h1>Recurve Men Team Bags Silver Medal at World Championship – Den Bosch</h1>
        <p id='demo'></p>
        </div>

        <div class="ui-g-6 ui-sm-12">
          <div style="    text-align: center;
          margin-top: 85px;">
          <button class="event-button"> Event Details</button>
          <button class="event-button">All Events </button>
          </div>

        </div>

      </div>
    </div> -->

  <div class="ui-g" *ngIf="eventsData.length > 0">
    <div class="ui-g-12 ui-sm-12">
      <div class="title-header" style="margin-top: 30px">
        <h1 style="margin-bottom:20px;">Latest Event</h1>
      </div>
      <div class="event-card">
        <div class="ui-g">
          <div class="ui-g-5 ui-lg-5 ui-md-12 ui-sm-12 padZero">
            <div
              class="event-card-banner"
              [style.backgroundImage]="
                'url(' + global?.basePathImage + eventsData[0]?.banner + ')'
              "
            ></div>
          </div>
          <div class="ui-g-7 ui-lg-7 ui-md-12 ui-sm-12 padZero">
            <div class="event-wrap">
              <div class="event-flex">
                <img
                  class="events-logo"
                  [src]="global?.basePathImage + eventsData[0]?.photo"
                  alt=""
                />
                <p class="event-title">
                  {{ eventsData[0]?.name }}
                </p>
              </div>
              <p class="event-description">
                {{ eventsData[0]?.description }}
              </p>
              <div class="min-flex" style="margin-top: 30px">
                <p *ngIf="eventsData[0]?.dateTime!==''" class="event-time" [id]="eventsData[0]?._id"></p>
                <button
                  (click)="eventDetails(eventsData[0]?._id)"
                  class="details-event"
                >
                  Event Details
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="ui-g-4 ui-sm-12">
      <div style="padding:20px">
      <p class="insta-feed">AAI Instagram Feeds</p>
      <div class="intagram">
        <div *ngFor="let data of instaPost" class="instagram-card">
          <a class="insta-card-banner" [href]="data?.permalink" target="_blank">
            <img class="insta-pic" [src]="data?.media_url" alt="" />
          </a>

          <p>{{ data.caption }}</p>
        </div>
      </div>
      </div>
    </div> -->
  </div>

  <div class="wrap-main-home">
    <div class="title-header">
      <h1  style="margin-bottom:20px;">Latest Updates</h1>
    </div>

    <div class="updates-section ui-g">
      <div class="ui-g-6 ui-sm-12">
        <p-tabView>
          <p-tabPanel *ngFor="let data of tabsData" [header]="data._id">
            <div
              *ngFor="let item of data.data | slice: 0:3"
              class="updates-content"
              (click)="updatesDetails(item._id)"
            >
              <h1>{{ item?.dateTime | date: "dd-MMM-yy " }}</h1>
              <p>{{ item?.name }}</p>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
      <div class="ui-g-6 ui-sm-12">
        <p class="Quick-heading">Quick Links</p>
        <div class="quick-links ui-g">
          <div class="ui-g-6 ui-sm-12">
            <div (click)="signup()" class="quick-box">
              <img class="link-img" src="assets/icons/quick/user.png" alt="" />
              <span>Become a Member</span>
            </div>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <div (click)="fame()" class="quick-box">
              <img class="link-img" src="assets/icons/quick/medal.png" alt="" />
              <span> Hall of fame</span>
            </div>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <a
              style="text-decoration: none"
              (click)="toRTI()"
            >
              <div class="quick-box">
                <img
                  class="link-img"
                  src="assets/icons/quick/information.png"
                  alt=""
                />
                <span> RTI</span>
              </div>
            </a>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <div (click)="toUnit()" class="quick-box">
              <img class="link-img" src="assets/icons/quick/user.png" alt="" />
              <span> Member Units</span>
            </div>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <a
              style="text-decoration: none"
              href="https://sportsauthorityofindia.nic.in/sai/ncoe"
              target="_blank"
            >
              <div class="quick-box">
                <img
                  class="link-img"
                  src="assets/icons/quick/university.png"
                  alt=""
                />
                <span>National Centre of Excellence</span>
              </div>
            </a>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <div class="quick-box">
              <img
                class="link-img"
                src="assets/icons/quick/press-machine.png"
                alt=""
              />
              <span (click)="toNews()"> Press Release</span>
            </div>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <div (click)="toArchers()" class="quick-box">
              <img
                class="link-img"
                src="assets/icons/quick/archer.png"
                alt=""
              />
              <span> Registered archers</span>
            </div>
          </div>

          <div class="ui-g-6 ui-sm-12">
            <div (click)="toGallery()" class="quick-box">
              <img
                class="link-img"
                src="assets/icons/quick/gallery.png"
                alt=""
              />
              <span> Gallery</span>
            </div>
          </div>
          <div class="ui-g-6 ui-sm-12">
            <a
              style="text-decoration: none"
  
           (click)="toSexualHarassment()"
            >
              <div class="quick-box">
                <img
                  class="link-img"
                  src="assets/icons/quick/information.png"
                  alt=""
                />
                <span>Internal Complaint Committee (ICC)</span>
              </div>
            </a>
          </div>
         
      
          <div class="ui-g-6 ui-sm-12">
            <a
              style="text-decoration: none"
              href="https://api.indianarchery.in/img1669642946951.pdf"
              target="_blank"
            >
              <div class="quick-box">
                <img
                  class="link-img"
                  src="assets/icons/quick/information.png"
                  alt=""
                />
                <span>Citizenship Norms</span>
              </div>
            </a>
          </div>
          <div class="ui-g-6 ui-sm-12">
            <a
              style="text-decoration: none"
             href="http://api.indianarchery.in/img1669635113714.pdf"
             target="_blank"
            >
              <div class="quick-box">
                <img
                  class="link-img"
                  src="assets/icons/quick/information.png"
                  alt=""
                />
                <span> Prevention of Age Fraud</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g wrap-main-home">
    <div class="ui-g-9 ui-lg-9 ui-md-12 ui-sm-12">
      <div class="video-section">
        <div class="title-header">
          <h1>Video Gallery</h1>
          <!-- <a href="">view all</a> -->
        </div>

        <div class="ui-g">
          <div class="ui-g-6 ui-lg-6 ui-md-6 ui-sm-12">
            <div class="video-card">
              <iframe
                width="100%"
                height="380"
                src="https://www.youtube.com/embed/urNRB5cNtWU"
              >
              </iframe>
              <div class="video-card-content">
                9th C.L.V.M. U14 National Championship | Shivam Rawat Amazing
                Slider Free Version.
              </div>
            </div>
          </div>

          <div
            class="ui-g-6 ui-lg-6 ui-md-6 ui-sm-12"
            *ngFor="let data of videoArray"
          >
            <div style="margin-top: 20px">
              <video
                *ngIf="data?.link"
                height="250"
                controls
                id="video-tag"
                [src]="data?.link"
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-3 ui-lg-3 ui-md-12 ui-sm-12">
      <div class="side-section">
        <div class="side-section-heading">
          <span>
            <img src="assets/icons/file.svg" alt="" />
          </span>
          Forms
        </div>

        <div class="side-section-content">
          <ul>
             <li >
              <a href="http://api.indianarchery.info/FORM-1%20Bid%20Form.doc" target="_blank">
               Bid Form
              </a>
            </li>
            <li *ngFor="let data of Forms">
              <a [href]="global.basePathImage + data.link" target="_blank">
                {{ data?.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="side-section">
        <div class="side-section-heading">
          <span>
            <img src="assets/icons/file.svg" alt="" />
          </span>
          AAI Election
        </div>

        <div class="side-section-content">
          <ul>
            <li *ngFor="let data of Elections">
              <a [href]="global.basePathImage + data.link" target="_blank">
                {{ data?.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="bignews-overlay-fixed">
    <div class="awards-section">
      <!-- <div class="title-header">
      <h1>Awards section</h1>
      <a href="">view all</a>
    </div> -->

      <h2 class="fame">Hall <span style="color: #9c1e4c"> of </span> Fame</h2>

      <div class="ui-g" style="margin-top: 30px">
        <div class="ui-g-3 ui-lg-3 ui-md-12 ui-sm-12">
          <div class="award-card" (click)="goToAward('Arjuna Award')">
            <p class="award-name">Arjuna Award</p>
            <div
              style="text-align: center; margin-top: 70px; margin-bottom: 50px"
            >
              <img class="award-image" src="assets/awards/Arjun.png" alt="" />
            </div>
            <!-- <div>
              <div class="border-b">
                <div
                  *ngFor="let data of ArjunAwards | slice: 0:1"
                  class="award-winner-card ui-g"
                >
                  <div class="ui-g-4">
                    <div class="award-image-wrap">
                      <img [src]="data.photo" alt="" />
                    </div>
                  </div>
                  <div class="ui-g-8">
                    <h2>{{ data?.name }}</h2>
                    <p>{{ data?.year }}</p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <div class="ui-g-3 ui-lg-3 ui-md-12 ui-sm-12">
          <div class="award-card" (click)="goToAward('Dronacharya Award')">
            <p class="award-name">Dronacharya Award</p>
            <div
              style="text-align: center; margin-top: 70px; margin-bottom: 50px"
            >
              <img
                class="award-image"
                src="assets/awards/Dronacharya.png"
                alt=""
              />
            </div>
            <!-- <div>
              <div class="border-b">
                <div
                  *ngFor="let data of DronaAwards | slice: 0:1"
                  class="award-winner-card ui-g"
                >
                  <div class="ui-g-4">
                    <div class="award-image-wrap">
                      <img [src]="data.photo" alt="" />
                    </div>
                  </div>
                  <div class="ui-g-8">
                    <h2>{{ data?.name }}</h2>
                    <p>{{ data?.year }}</p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>

        <div class="ui-g-3 ui-lg-3 ui-md-12 ui-sm-12">
          <div class="award-card" (click)="goToAward('Dhyan Chand Award')">
            <p class="award-name">Dhyan chand Award</p>
            <div
              style="text-align: center; margin-top: 70px; margin-bottom: 50px"
            >
              <img
                class="award-image"
                src="assets/awards/Dhyan-Chand.png"
                alt=""
              />
            </div>
          
          </div>
        </div>

        <div class="ui-g-3 ui-lg-3 ui-md-12 ui-sm-12">
          <div class="award-card" (click)="goToAward('Padmashree Award')">
            <p class="award-name">Padmashree Award</p>
            <div
              style="text-align: center; margin-top: 70px; margin-bottom: 50px"
            >
              <img
                class="award-image"
                src="assets/awards/Padam-Shri.png"
                alt=""
              />
            </div>
         
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-g wrap-main-home">
    <div class="ui-g-12 ui-sm-12">
      <div class="video-section">
        <div class="title-header">
          <h1>Photo Gallery</h1>
        </div>

        <div class="ui-g">
          <div
            *ngFor="let data of gallery"
            class="ui-g-4 ui-lg-4 ui-md-6 ui-sm-12"
          >
            <div
              class="image-card"
              [style.backgroundImage]="'url(' + data?.link + ')'"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
